/**
 * Dashboard constants - Alert filters and API endpoints for status checks
 */

export const ALERT_FILTERS = [
    { name: 'Alerte vente', color: 'purple', tooltip: 'Aucune vente depuis 3 jours et nombre de bouteilles pleine > 0', key: 'salesAlert' },
    { name: 'Alerte TPA', color: 'green', tooltip: 'Derniere communication du TPA depuis plus de 3 jours', key: 'tpaAlert' },
    { name: 'Alerte ping nuage', color: 'blue', tooltip: 'Dernier ping nuage depuis plus de 3 jours', key: 'pingAlert' },
    { name: 'Alerte vente annulée', color: 'yellow', tooltip: 'Pourcentage de vente annulé > 30 % et nombre de vente sur les 4 derniers jours > 10', key: 'cancelledSalesAlert' },
    { name: 'Com rack KO', color: 'orange', tooltip: 'Communication rack NOK', key: 'rackAlert' },
    { name: 'Tension faible', color: 'red', tooltip: 'Au moins une des tensions batterie borne ou présentoir est < 11.7 V', key: 'voltageAlert' },
    { name: 'Carte mère freeze', color: 'cyan', tooltip: 'Absence de ping > 24h, tension > 12V sur 7 jours, autodiag présent la nuit', key: 'motherboardFreezeAlert' },
    { name: 'Électronique (fusible)', color: 'pink', tooltip: 'Pas de ping la nuit pendant plus de 7 jours', key: 'fuseAlert' },
    { name: 'Batterie', color: 'deep-orange', tooltip: 'Absence de ping > 24h et tension nuit < 12V sur 7 jours', key: 'batteryAlert' },
];

export const API_STATUS_ENDPOINTS = [
    { name: 'Extranet (https://vm-manage.we-deal.fr)', url: 'https://corsproxy.io/?https://vm-manage.we-deal.fr' },
    { name: 'Connexion webservice', url: 'https://corsproxy.io/?https://vm-manage.we-deal.fr/webapi_kiosk/' },
    { name: 'Connexion Back / BDD', url: 'https://corsproxy.io/?https://vm-manage.we-deal.fr/webapi_admin/' },
    { name: 'Passerelle monétique', url: 'https://corsproxy.io/?https://we-deal.smart-pos.eu/' }
];

/**
 * Get the alert key from filter name
 * @param {string} filterName
 * @returns {string|null}
 */
export const getAlertKeyFromFilterName = (filterName) => {
    const filter = ALERT_FILTERS.find(f => f.name === filterName);
    return filter ? filter.key : null;
};

/**
 * Filter kiosks based on selected filters and options
 * @param {Array} kiosks
 * @param {Object} options
 * @returns {Array}
 */
export const filterKiosks = (kiosks, options) => {
    const { ticketFilter, selectedFilters, useXorMode, selectedTags } = options;

    return kiosks.filter(kiosk => {
        // Ticket filter
        let ticketMatch = true;
        if (ticketFilter === 'with') {
            ticketMatch = kiosk.openedTicket === true;
        } else if (ticketFilter === 'without') {
            ticketMatch = kiosk.openedTicket === false;
        }

        // Alert filters
        let alertMatch = true;
        if (selectedFilters.length > 0) {
            const matches = selectedFilters.map(filterName => {
                const alertKey = getAlertKeyFromFilterName(filterName);
                return alertKey ? kiosk[alertKey] : false;
            });

            const count = matches.filter(Boolean).length;
            alertMatch = useXorMode
                ? count > 0
                : count === selectedFilters.length;
        }

        // Tag filter
        const tagMatch =
            !selectedTags || selectedTags.length === 0
                ? true
                : kiosk.tags?.some(tag => selectedTags.includes(tag.id));

        return ticketMatch && alertMatch && tagMatch;
    });
};

export default {
    ALERT_FILTERS,
    API_STATUS_ENDPOINTS,
    getAlertKeyFromFilterName,
    filterKiosks
};
